export default __webpack_public_path__ + "static/media/product-3.956ab0ba.png";